export default __webpack_public_path__ + "static/mobile-development-2ad59a291949665722ac9b64b574ffae.webp";